import NavigationLink from 'components/links/NavigationLink';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const MainNavigationLink: FunctionComponent<Props> = ({
    className = '',
    link,
    onClick,
    testId = TEST_ID,
    text
}) => (
    <NavigationLink className={className} onClick={onClick} testId={testId} text={text} to={link} />
);

export default MainNavigationLink;
